'use client';

import { DialogContent, type DialogContentProps } from '@chakra-ui/react';

/**
 * Precanned DialogContent: fixed, centered, fit-content.
 * Use for standard small modals; override props (e.g. maxW) as needed.
 */
export const CenteredDialogContent = (props: DialogContentProps) => (
  <DialogContent
    maxW="md"
    position="fixed"
    inset={0}
    m="auto"
    h="fit-content"
    maxH="fit-content"
    zIndex="modal"
    {...props}
  />
);
